var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footercom"},[_c('div',{staticClass:"footertop flex-around"},[_c('div',{staticClass:"fotext point",on:{"click":function($event){return _vm.goPage('/index/rules?type=3')}}},[_vm._v("关于我们")])]),_c('div',{staticClass:"footerbtm text-center"},[_vm._v(" COPYRIGHT © 2024 辽ICP备19018558号 ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }